import { type TOptional } from '@/types/common';

import { type DestinationRegion, type DestinationsFilterData, type TSelectedRegionInfo } from '../types';

export const LABEL_MAX_SEGMENTS = 2;

const makeDestinationsPillLabel = (
  destinationsFilterData: DestinationsFilterData,
  selectedRegionInfo?: TSelectedRegionInfo,
): TOptional<string> => {
  const { destinationType } = selectedRegionInfo || {};

  if (destinationType) {
    const regions: DestinationRegion[] = destinationsFilterData[destinationType];
    const labels = [] as string[];

    for (const region of regions) {
      const { allSelected, label, selectedItemsIds } = region;

      if (allSelected) {
        labels.push(label);
      } else if (selectedItemsIds.length) {
        labels.push(`${label} (${selectedItemsIds.length})`);
      }

      if (labels.length >= LABEL_MAX_SEGMENTS) break;
    }
    if (labels.length) return labels.join(', ');
  }
};

export default makeDestinationsPillLabel;
